<template>
  <div class="business-cooperation-page">
    <p class="title">商务合作</p>
    <p class="text">
      富有远见和眼光的商业品牌，欢迎考虑联系一席进行赞助，与我们合作过的品牌包括：上汽通用别克、华泰证券、东方树叶、米其林中国、腾讯公益、积家手表、荣耀手机、贝壳等。<br />
      <br />
      经过10年的发展，一席已成为华语地区第一的演讲品牌，已有来自世界各地的近千位讲者走上一席舞台，网络视频播放量已超过15亿次。<br />
	  <br />
	  一席还推出了访谈节目「一席枝桠」、视频课程「一席万象」等。<br />
      <br />
      所有合作的咨询事宜请务必发送邮件至：<span style="color: #6ea7e2">yixitv@vip.163.com</span><br />
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.business-cooperation-page {
  padding: 40px 50px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 10px;
}
.image {
  display: block;
}
.text {
  font-size: 14px;
  color: #333;
  line-height: 24px;
}
</style>
